import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/service/auth.service';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';
import { MQTTOperation } from 'src/app/Service/mqttoperation.service';
import { GenericValidator } from 'src/app/validation/general-validation';
import { DatePipe, formatDate } from '@angular/common';
import { UploadFileComponent } from '../upload-file/upload-file.component';
import { ConfirmDialogComponent } from 'src/app/Common/confirm-dialog/confirm-dialog.component';
import { ConfigurationsService } from 'src/app/Service/configurations.service';
import { AlertMasterService } from 'src/app/Service/alertmaster.service';
import { AddnewparameterconfigComponent } from '../addnewparameterconfig/addnewparameterconfig.component';

@Component({
  selector: 'app-analogconfig-parameter',
  templateUrl: './analogregisterpanel.html'
})
export class AnalogRegisterpanelComponent implements OnInit {
  isSaveClick: boolean = false;
  IsreadOnly: boolean = false;
  DisplayButton: boolean = false;
  RoleName: string = '';
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;
  displayMessage: { [key: string]: string } = {};
  private ListvalidationMessages: { [key: string]: { [key: string]: string } };
  private ListgenericValidator: GenericValidator;
  ListdisplayMessage: { [key: string]: string } = {};
  RegisterData: [];
  registerpanelForm: FormGroup;
  deviceSettingsForm: FormGroup

  ismaxDisable = true;
  registermax: any;
  DropDownList: any;
  errorMsg: string = '';
  successMsg: string = '';
  errorMsgdevice: string = '';
  successMsgdevice: string = '';
  DatatypeList: [];
  DecimalPointList: [];
  FunctionCodeList: [];
  DecimalPointFrontList: [];
  UserPrefData: any[] = [];
  minSlID: number = 0;
  maxSlID: number = 0;
  SlaveMessage: string = '';
  EnergyMeterdata: any = [];
  listRegisterdata: any;
  flag: boolean = true;
  numberOfRegister: any;
  EnergyMeterID: any;
  PublishRegisterJson: any[] = [];
  MaximumRegister: number = 0;
  List: any[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
  MaxRegister: string = '';
  DeviceProtocol: string = '';
  EMIndex: number = 0;
  KeyID: string = '';
  IsChange: boolean = true;
  isSaved: boolean = false;
  ActionList: any[] = [];
  ReqObj: { [key: string]: any } = {};
  RNameObj: { [key: string]: any } = {};
  selectedmetername: any
  selectedmeterid: any
  energyListOfPopup: any = []
  newdata: any;
  Addformulamsg: string;
  isDivVisible: boolean = false
  showvalue: any = false
  ModbusRequestTypeList: any = [];
  devicecounterlist: any = []
  analogmeterflag: any = false
  selectedslaveid: number;
  UnitList: any = []
  AlertList: any = []
  defaultAlertId: any = 1
  CompanyCode: any
  MeterConfigurationdata: any;
  RegisterDataparam: any;
  UserId: string;
  CalibrationCertificatefilename: any;

  normalizeAlertId(value: any): number {
    if (value == null || value === '' || value === 0 || value === '0') {
      return this.defaultAlertId;
    }
    return Number(value);
  }

  resolveAlertId(element?: any): number {
    return this.normalizeAlertId(element?.AlertId ?? this.EnergyMeterdata?.AlertId ?? this.defaultAlertId);
  }

  compareAlertId = (a: any, b: any): boolean => {
    if (a == null && b == null) {
      return true;
    }
    if (a == null || b == null) {
      return false;
    }
    return Number(a) === Number(b);
  };

  applyDefaultAlertIdsToRows(): void {
    const registerArray = this.registerpanelForm?.get('listRegisterdata') as FormArray;
    if (!registerArray) {
      return;
    }
    registerArray.controls.forEach((ctrl) => {
      const alertCtrl = ctrl.get('AlertId');
      if (alertCtrl) {
        const normalized = this.normalizeAlertId(alertCtrl.value);
        alertCtrl.setValue(normalized, { emitEvent: false });
      }
    });
  }

  meterConfiguration: {
    SerialNumber: any; LastCalibrationDate: string; LastCalibrationDueDate: string; CalibrationCertificate: any; EnergymeterMasterId: any;
    UserId: string;
  };
  constructor(public datepipe: DatePipe, private configService: ConfigurationsService, public fb: FormBuilder, private GSMConfigService: GSMConfigurationService, private alertMasterService: AlertMasterService, private authService: AuthService, private form: FormBuilder, private dialog: MatDialog, private mqttoperation: MQTTOperation, public dialogRef: MatDialogRef<AnalogRegisterpanelComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
    this.selectedmetername = data.EnergyMeterdata.selectedmetername
    if (data.EnergyMeterdata.metertype == 2) {
      this.analogmeterflag = true
    }
    this.devicecounterlist = data.EnergyMeterdata.devicecounterlist
    if (data && data.EnergyMeterdata.RegisterData) {
      this.EnergyMeterdata = data.EnergyMeterdata.RegisterData;
      this.energyListOfPopup = data.EnergyMeterdata.RegisterData.listRegisterdata
    }
    if (data && data.EnergyMeterdata.meterConfiguration) {
      this.MeterConfigurationdata = data.EnergyMeterdata.meterConfiguration;
    }
    this.Addformulamsg = '*Please first save register data.'
    this.DeviceProtocol = data.EnergyMeterdata.DeviceProtocol;
    this.EnergyMeterID = data.EnergyMeterdata.EMID;
    this.EMIndex = data.EnergyMeterdata.EMIndex;
    this.KeyID = data.EnergyMeterdata.KeyID;
    this.CompanyCode = localStorage.getItem("CompanyCode")

    // Raise Validation message
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages = resp.registerpanelForm;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });

    this.authService.getValidationMessage().subscribe(resp => {
      this.ListvalidationMessages = resp.listRegisterdata;
      this.ListgenericValidator = new GenericValidator(this.ListvalidationMessages);
    });

  }

  ngOnInit(): void {
    if (this.RoleName == 'PortalAdmin') {
      this.DisplayButton = false;
      this.IsreadOnly = true;
      const control = <FormArray>this.registerpanelForm.controls['listRegisterdata'];
      control.disable();
    }
    else {
      this.DisplayButton = true;
      this.IsreadOnly = false;
    }
    this.isDivVisible = false
    this.deviceSettingsForm = this.form.group({
      SerialNumber: [''],
      LastCalibrationDate: [new Date()],
      LastCalibrationDueDate: [new Date()],
    })
    this.registerpanelForm = this.form.group({
      EnergymeterMasterID: [0],
      SlaveID: ['', [Validators.required]],
      MaxRegisters: ['', [Validators.required]],
      ReadRegisterQuantity: ['', [Validators.required]],
      ModbusRequestType: ['0', [Validators.required]],
      StartRegisterNumber: ['', [Validators.required]],
      'listRegisterdata': this.form.array([this.fb.group({
        RegisterName: ['', [Validators.required]],
        RegisterNO: ['', [Validators.required]],
        DataType: ['', [Validators.required]],
        FunctionCode: ['', [Validators.required]],
        DecimalPoint: ['', [Validators.required]],
        ReadWriteAction: ['', [Validators.required]],
        IsDisplayGraph: [''],
        IsTotalizer: [''],
        AlertId: [1, [Validators.required]],
        HighThresoldValue: [0, [Validators.required]],
        LowThresoldValue: [0, [Validators.required]],
        Unit: ["NONE", Validators.required],
        FullScale: [0, Validators.required],
        Location: ['', Validators.required],
        ZeroScale: [0, Validators.required],
        RegisterSeq: [0],
        RegisterDataId: [0],
        DecimalPointForFront: ['', [Validators.required]],
        IsFromParameterConfig: [''],

      })])
    });

    this.Getdropdownlist();
    this.GetAlertList();
    if (this.MeterConfigurationdata != null) {

      this.SetMeterConfigurationdata()
    }
    if (this.EnergyMeterdata != null && this.EnergyMeterID == 0) {
      this.SetRegisterData();
      this.IsChange = true;
      this.isSaved = false;
    }
    else if (this.EnergyMeterID > 0) {
      this.GetRegisterdata(this.EnergyMeterID);
      this.GetMeterConfigurationData(this.EnergyMeterID);
    }

    this.UserPrefData = JSON.parse(localStorage.getItem('UserPref'));

    if (this.UserPrefData) {
      this.minSlID = this.UserPrefData.filter(x => x.PrefKey == 'MinSlaveID')[0].PrefValue;
      this.maxSlID = this.UserPrefData.filter(x => x.PrefKey == 'MaxSlaveID')[0].PrefValue;
      this.MaximumRegister = this.DeviceProtocol == 'HTTP' ? this.UserPrefData.filter(x => x.PrefKey == 'HTTP')[0].PrefValue : this.UserPrefData.filter(x => x.PrefKey == 'FTP')[0].PrefValue;
    }

    // Call service for validation on valu change
    this.registerpanelForm.valueChanges.subscribe(val => {
      if (this.isSaved == true) {
        this.IsChange = true;
      }
      if (this.genericValidator != undefined) {
        this.displayMessage = this.genericValidator.processMessages(this.registerpanelForm, false, this.validationMessages);
      }
    });

    this.RoleName = localStorage.getItem('RoleName');
  }


  OnImport(value) {
    if (this.EnergyMeterdata.listRegisterdata) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '35%',

        data: {
          entityName: 'Register Config'
        },
        disableClose: true

      });
      dialogRef.afterClosed().subscribe(
        (result) => {
          if (result == 'Y') {
            this.UploadExcelFile();
          }
        }
      );
    }
    else {
      this.UploadExcelFile();
    }
  }

  UploadExcelFile() {
    const UploadLogodialogref = this.dialog.open(UploadFileComponent,
      {
        data: { isFromMeterConfig: 'Y' }
      });
    UploadLogodialogref.afterClosed().subscribe((result) => {
      if (result && result.length > 0) {
        this.EnergyMeterdata.listRegisterdata = result;
        this.flag = false;
        const control = <FormArray>this.registerpanelForm.controls['listRegisterdata'];
        control.clear();
        control.push(
          this.form.group({
            RegisterName: new FormControl('', [Validators.required]),
            RegisterNO: new FormControl(1, [Validators.required]),
            DataType: new FormControl('0', [Validators.required]),
            FunctionCode: new FormControl('1', [Validators.required]),
            DecimalPoint: new FormControl('0', [Validators.required]),
            ReadWriteAction: new FormControl('0', [Validators.required]),
            IsDisplayGraph: new FormControl(false),
            IsTotalizer: new FormControl(false),
            AlertId: new FormControl(this.defaultAlertId, [Validators.required]),
            HighThresoldValue: new FormControl(0, [Validators.required]),
            LowThresoldValue: new FormControl(0, [Validators.required]),
            RegisterSeq: 0,
            Unit: new FormControl("NONE", [Validators.required]),
            ZeroScale: new FormControl(0, [Validators.required]),
            FullScale: new FormControl(0, [Validators.required]),
            Location: new FormControl(' ', [Validators.required]),
            DecimalPointForFront: new FormControl('0', [Validators.required]),
            IsFromParameterConfig: 'N',
          })
        );
      }
    });
  }

  GetRegisterdata(id) {
    if (id != null) {
      this.GSMConfigService.GetRegisterdata(id, 'N', 'N', '').subscribe(
        (result) => {
          if (result != null) {
            this.selectedslaveid = result.SlaveID
            this.EnergyMeterdata = result;
            this.energyListOfPopup = result.listRegisterdata
            this.SetRegisterData();
            this.IsChange = false;
            this.isSaved = true;
          }

          this.selectedmeterid = id
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }
  GetMeterConfigurationData(id) {
    if (id != null) {
      this.GSMConfigService.GetMeterConfigurationData(id).subscribe(
        (result) => {
          if (result != null) {
            this.MeterConfigurationdata = result;
            this.deviceSettingsForm.patchValue({
              EnergymeterMasterID: this.EnergyMeterID,
              SerialNumber: this.MeterConfigurationdata.SerialNumber,
              LastCalibrationDate: this.MeterConfigurationdata.LastCalibrationDate,
              LastCalibrationDueDate: this.MeterConfigurationdata.LastCalibrationDueDate,
            });
            this.CalibrationCertificatefilename = this.MeterConfigurationdata.CalibrationCertificate
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }
  SetMeterConfigurationdata() {
    this.deviceSettingsForm.patchValue({
      EnergymeterMasterID: this.EnergyMeterID,
      SerialNumber: this.MeterConfigurationdata.SerialNumber,
      LastCalibrationDate: this.MeterConfigurationdata.LastCalibrationDate,
      LastCalibrationDueDate: this.MeterConfigurationdata.LastCalibrationDueDate,
    });
    this.CalibrationCertificatefilename = this.MeterConfigurationdata.CalibrationCertificate
  }
  SetRegisterData() {
    this.flag = false;
    const control = <FormArray>this.registerpanelForm.controls['listRegisterdata'];
    this.registerpanelForm.patchValue({
      EnergymeterMasterID: this.EnergyMeterID,
      SlaveID: this.EnergyMeterdata.SlaveID,
      MaxRegisters: this.EnergyMeterdata.MaxRegisters,
      ModbusRequestType: this.EnergyMeterdata.ModbusRequestType.toString(),
      StartRegisterNumber: this.EnergyMeterdata.StartRegisterNumber,
      ReadRegisterQuantity: this.EnergyMeterdata.ReadRegisterQuantity
    });
    this.EnergyMeterdata.ModbusRequestType == 1 ? this.showvalue = true : false
    this.EnergyMeterdata.ModbusRequestType.toString() == 1 ? this.showvalue == true : false

    control.clear();

    if (this.energyListOfPopup) {
      this.energyListOfPopup.forEach((element, i) => {

        if (element?.TagId != "DataCount") {
          control.push(
            this.form.group({
              RegisterName: new FormControl(element?.RegisterName, [Validators.required]),
              RegisterNO: new FormControl(element?.RegisterNO ? element?.RegisterNO : 1, [Validators.required]),
              DataType: new FormControl(element?.DataType ? element?.DataType.toString() : '0', [Validators.required]),
              FunctionCode: new FormControl(element?.FunctionCode.toString() ? element?.FunctionCode.toString() : '1', [Validators.required]),
              DecimalPoint: new FormControl(element?.DecimalPoint ? element?.DecimalPoint.toString() : '0', [Validators.required]),
              ReadWriteAction: new FormControl(element?.ReadWriteAction ? element?.ReadWriteAction.toString() : '0', [Validators.required]),
              IsDisplayGraph: new FormControl(element?.IsDisplayGraph ? (element?.IsDisplayGraph.toString() == 'true') ? true : false : false),
              IsTotalizer: new FormControl(element?.IsTotalizer ? (element?.IsTotalizer.toString() == 'true') ? true : false : false),
              AlertId: new FormControl(this.resolveAlertId(element), [Validators.required]),
              HighThresoldValue: new FormControl(element?.HighThresoldValue ? element?.HighThresoldValue : 0, [Validators.required]),
              LowThresoldValue: new FormControl(element?.LowThresoldValue ? element?.LowThresoldValue : 0, [Validators.required]),
              RegisterSeq: element?.RegisterSeq ? element?.RegisterSeq : 0,
              Unit: new FormControl(element?.Unit ? element?.Unit : "NONE", [Validators.required]),
              ZeroScale: new FormControl(element?.ZeroScale ? element?.ZeroScale : 0, [Validators.required]),
              FullScale: new FormControl(element?.FullScale ? element?.FullScale : 0, [Validators.required]),
              Location: new FormControl(element?.Location ? element?.Location : ' ', [Validators.required]),
              RegisterDataId: element?.RegisterDataId,
              DecimalPointForFront: new FormControl(element?.DecimalPointForFront ? element?.DecimalPointForFront.toString() : '0', [Validators.required]),
              IsFromParameterConfig: this.newdata?.IsFromParameterConfig ? this.newdata?.IsFromParameterConfig : element?.IsFromParameterConfig,
              Formula: element?.Formula,
              TagId: element?.TagId,
              TempFormula: element?.TempFormula,

            })
          );
        }
      });

    }
    else {
      control.push(
        this.form.group({
          RegisterName: new FormControl('', [Validators.required]),
          RegisterNO: new FormControl(1, [Validators.required]),
          DataType: new FormControl('0', [Validators.required]),
          FunctionCode: new FormControl('1', [Validators.required]),
          DecimalPoint: new FormControl('0', [Validators.required]),
          ReadWriteAction: new FormControl('0', [Validators.required]),
          IsDisplayGraph: new FormControl(false),
          IsTotalizer: new FormControl(false),
          AlertId: new FormControl(this.defaultAlertId, [Validators.required]),
          HighThresoldValue: new FormControl(0, [Validators.required]),
          LowThresoldValue: new FormControl(0, [Validators.required]),
          RegisterSeq: 0,
          Unit: new FormControl("NONE", [Validators.required]),
          FullScale: new FormControl(0, [Validators.required]),
          Location: new FormControl(' ', [Validators.required]),
          ZeroScale: new FormControl(0, [Validators.required]),
          DecimalPointForFront: new FormControl('0', [Validators.required]),
          IsFromParameterConfig: 'N',
        })
      );
    }

    this.applyDefaultAlertIdsToRows();
    this.normalizeUnitValues();
  }

  normalizeUnitValues(): void {
    if (!this.UnitList?.length || !this.registerpanelForm?.get('listRegisterdata')) {
      return;
    }
    const rows = this.registerpanelForm.get('listRegisterdata') as FormArray;
    rows.controls.forEach((row: FormGroup) => {
      const unitControl = row.get('Unit');
      const current = unitControl?.value;
      if (current == null || current === '') {
        return;
      }
      const match = this.UnitList.find((item: any) =>
        item.CodeDisplayName === current || String(item.CodeValue) === String(current)
      );
      if (match) {
        unitControl.patchValue(match.CodeDisplayName, { emitEvent: false });
      }
    });
  }


  // call for Getdropdownlist
  Getdropdownlist() {
    let reqpara = 'DataType,FunctionCode,DecimalPoint,ReadWriteAction,DecimalPointForFront,ModbusRequestType,Units';
    this.GSMConfigService.Getdropdownlist(reqpara).subscribe(
      (result) => {
        this.DropDownList = result;
        this.DatatypeList = this.DropDownList['listDataType'];
        this.FunctionCodeList = this.DropDownList['listFunctionCode'];
        this.DecimalPointList = this.DropDownList['listDecimalPoint'];
        this.ActionList = this.DropDownList['listaction'];
        this.DecimalPointFrontList = this.DropDownList['listDecimalPointForFront'];
        this.ModbusRequestTypeList = this.DropDownList['listModbusRequestType'];
        this.UnitList = this.DropDownList['listUnits'] || [];
        this.normalizeUnitValues();

      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  GetAlertList() {
    this.alertMasterService.GetAlertList({ AlertName: '', Severity: '' }).subscribe(
      (result) => {
        if (result && Array.isArray(result.AlertMasterLists) && result.AlertMasterLists.length > 0) {
          this.AlertList = result.AlertMasterLists;
          this.applyDefaultAlertIdsToRows();
        } else {
          this.AlertList = [];
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }
  // on change all dropdown List
  OnChange(type) {
    const control = <FormArray>this.registerpanelForm.controls['listRegisterdata'];
    var data: any;
    if (control.status == 'INVALID') {
      control.value.forEach((element, i) => {
        var listdata = (this.registerpanelForm.get('listRegisterdata') as FormArray).at(i);

        if (type == 'dataType') {
          if (control.value[i].DataType == '') {
            listdata.get('DataType').patchValue(control.value[0].DataType);
          }
        }
        if (type == 'FunctionCode') {
          if (control.value[i].FunctionCode == '') {
            listdata.get('FunctionCode').patchValue(control.value[0].FunctionCode);
          }
        }
        if (type == 'DecimalPoint') {
          if (control.value[i].DecimalPoint == '') {
            listdata.get('DecimalPoint').patchValue(control.value[0].DecimalPoint);
          }
        }
        if (type == 'ReadWriteAction') {
          if (control.value[i].ReadWriteAction == '') {
            listdata.get('ReadWriteAction').patchValue(control.value[0].ReadWriteAction);
          }
        }
      });
    }
  }

  OnShow(value) {
    const divElement = document.getElementById('divToRemove');
    if (divElement) {
      divElement.parentNode.removeChild(divElement);
    }
    this.flag = false;
    this.numberOfRegister = value;
    const control = <FormArray>this.registerpanelForm.controls['listRegisterdata'];

    if (control.length < this.numberOfRegister) {
      for (let i = control.length; i < this.numberOfRegister; i++) {
        control.push(this.AddMaxRegisterdata(i));
      }
    }
    else {
      for (let i = control.length; i >= this.numberOfRegister; i--) {
        control.removeAt(i);
      }
    }
    this.EnergyMeterdata.MaxRegisters = value
    this.applyDefaultAlertIdsToRows();
  }

  AddMaxRegisterdata(index) {
    return this.fb.group({
      RegisterName: ['', [Validators.required]],
      RegisterNO: ['', [Validators.required]],
      DataType: ['', [Validators.required]],
      FunctionCode: ['', [Validators.required]],
      DecimalPoint: ['', [Validators.required]],
      ReadWriteAction: ['', [Validators.required]],
      IsDisplayGraph: [''],
      IsTotalizer: [''],
      AlertId: [this.defaultAlertId, [Validators.required]],
      HighThresoldValue: [0, [Validators.required]],
      LowThresoldValue: [0, [Validators.required]],
      Unit: ["NONE", [Validators.required]],
      FullScale: [0, [Validators.required]],
      Location: ['', [Validators.required]],
      ZeroScale: [0, [Validators.required]],
      RegisterSeq: index,
      RegisterDataId: [0],
      DecimalPointForFront: ['', [Validators.required]],
      IsFromParameterConfig: 'N',
      Formula: '',
      TagId: '',
      TempFormula: '',

    });
  }

  OnSubmit() {
    this.isSaveClick = true;
    if (this.registerpanelForm.get('listRegisterdata').invalid) {
      this.errorMsg = 'Need to fill all fields of Register Data List !!';

      return;
    }
    if ((this.registerpanelForm.value.ModbusRequestType == "1") && (this.registerpanelForm.value.StartRegisterNumber == '' || this.registerpanelForm.value.ReadRegisterQuantity == '' || this.registerpanelForm.value.SlaveID == null || this.registerpanelForm.value.MaxRegisters == null) && this.analogmeterflag == false) {
      this.registerpanelForm.updateValueAndValidity();
      this.registerpanelForm.markAllAsTouched();

      this.displayMessage = this.genericValidator.processMessages(this.registerpanelForm, true, this.validationMessages);

      return;
    } else if ((this.registerpanelForm.value.ModbusRequestType == "0") && (this.registerpanelForm.value.SlaveID == null || this.registerpanelForm.value.MaxRegisters == null) && this.analogmeterflag == false) {
      this.registerpanelForm.updateValueAndValidity();
      this.registerpanelForm.markAllAsTouched();

      this.displayMessage = this.genericValidator.processMessages(this.registerpanelForm, true, this.validationMessages);

      return;
    }
    if ((this.EnergyMeterdata.MaxRegisters) != (this.registerpanelForm.value.listRegisterdata.length) && this.analogmeterflag == false) {

      this.errorMsg = 'No. of registers in the list should be same as Maximum Register Field !!';
      return;
    }
    if (this.analogmeterflag == false) {
      this.ValidateFields('Register');
    }
    this.ValidateFields('SlaveID');

    if ((this.registerpanelForm.value.ModbusRequestType == "0") && (this.registerpanelForm.value.ReadRegisterQuantity == '' || this.registerpanelForm.value.ReadRegisterQuantity != '') && this.analogmeterflag == false) {

      this.registerpanelForm.value.ReadRegisterQuantity = 0
    }
    if ((this.registerpanelForm.value.ModbusRequestType == "0") && (this.registerpanelForm.value.StartRegisterNumber == '' || this.registerpanelForm.value.StartRegisterNumber != '') && this.analogmeterflag == false) {

      this.registerpanelForm.value.StartRegisterNumber = 0
    }
    const objdevice = {
      SerialNumber: this.deviceSettingsForm.value.SerialNumber,
      LastCalibrationDate: this.deviceSettingsForm.value.LastCalibrationDate
        ? [formatDate(this.deviceSettingsForm.value.LastCalibrationDate, 'yyyy-MM-dd', 'en')][0]
        : null,
      LastCalibrationDueDate: this.deviceSettingsForm.value.LastCalibrationDueDate
        ? [formatDate(this.deviceSettingsForm.value.LastCalibrationDueDate, 'yyyy-MM-dd', 'en')][0]
        : null,
      CalibrationCertificate: this.CalibrationCertificatefilename,
      EnergymeterMasterId: this.EnergyMeterID ? this.EnergyMeterID : 0,

      UserId: localStorage.getItem("UserId")
    };
    this.meterConfiguration = objdevice
    let reqparam = { ...this.registerpanelForm.value };
    this.RegisterDataparam = reqparam
    if (this.analogmeterflag == false) {
      if (this.SlaveMessage == '' && this.MaxRegister == '') {

        if (this.EnergyMeterID > 0) {

          this.SaveRegisterData(reqparam);
        }
        else {
          var obj = {
            RegisterData: this.RegisterDataparam,
            meterConfiguration: this.meterConfiguration
          }
          this.dialogRef.close(obj);
        }
        this.IsChange = false;
      }
      else {
        return;
      }
    } else {
      if (this.registerpanelForm.value.SlaveID != '0' || this.registerpanelForm.value.SlaveID != 0) {
        let reqparam = { ...this.registerpanelForm.value };
        reqparam.MaxRegisters = 1
        reqparam.StartRegisterNumber = 0
        reqparam.ReadRegisterQuantity = 0

        if (this.EnergyMeterID > 0) {
          this.SaveRegisterData(reqparam);
        }
        else {
          this.dialogRef.close(reqparam);
        }
        this.IsChange = false;
        // this.dialogRef.close(reqparam);
      }
      else {
        return;
      }
    }
  }

  DownloadSampleExcel() {
    let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'usermanual' + '/RMS_Meter_Configuration.xlsx'
    window.open(serviceCallURL);
  }

  // Save Register Data
  SaveRegisterData(requestparam) {
    this.errorMsg = '';
    this.successMsg = '';
    this.GSMConfigService.SaveRegisterData(requestparam).subscribe(
      (result) => {
        if (result) {
          this.successMsg = 'Values Submitted Successfully';
          this.isSaveClick = false;
        }

      },
      (error) => {
        this.errorMsg = error;
      });
  }

  OnCancel() {
    this.dialogRef.close();
  }

  Close() {
    this.dialogRef.close();
  }

  // On Key Press Event
  onKeypressEvent(event, Type) {
    this.ValidateFields(Type);
  }

  // Validate Fields
  ValidateFields(Type) {
    var realValue = '';
    if (Type == 'SlaveID') {
      realValue = this.registerpanelForm.value.SlaveID;
      if (+realValue > this.maxSlID || +realValue < this.minSlID) {
        this.SlaveMessage = 'Slave ID should be greater than ' + this.minSlID + ' and less than ' + this.maxSlID;
        return;
      }
      else {
        this.SlaveMessage = '';
      }
    }
    else if (Type == 'Register') {
      realValue = this.registerpanelForm.value.MaxRegisters;
      if (+realValue > this.MaximumRegister) {
        this.MaxRegister = 'Maximum Register should be less than or equal to ' + this.MaximumRegister;
        return;
      }
      else {
        this.MaxRegister = '';
      }
    }
  }

  float2int(value) {
    return value | 0;
  }

  // Send Register JSON 
  SendRegisterJSON() {
    const formData = this.registerpanelForm.value.listRegisterdata[0]
    this.UnitList.forEach((code: any) => {
      if (code.CodeDisplayName === formData.Unit) {
        formData.Unit = code.CodeValue;
      }
    });

    const { ZeroScale, FullScale, RegisterName, Unit, Location } = formData;
    const req3Json: any = {
      Topic: '11000'
    };
    const prefix = String.fromCharCode(64 + this.selectedslaveid);
    req3Json[`${prefix}1`] = ZeroScale;
    req3Json[`${prefix}11`] = FullScale;
    req3Json[`${prefix}2`] = RegisterName;
    req3Json[`${prefix}3`] = Unit;
    req3Json[`${prefix}4`] = Location;
    const reqObj3 = {
      Topic: this.KeyID,
      PublishMessageJson: JSON.stringify(req3Json)
    };
    const data = [reqObj3];
    const reqobj = {
      Data: data
    };
    this.SendDatabyMQTT(reqobj);
  }
  // // Send Register JSON
  // SendRegisterJSON() {

  //   var MaxRegister = this.registerpanelForm.value.MaxRegisters;
  //   var SlaveID = this.registerpanelForm.value.SlaveID;

  //   var Reqest_no = 0;
  //   var index = 0;

  //   var Total_length = this.registerpanelForm.value.listRegisterdata.length;
  //   var Total_req = this.float2int(Total_length / 10);


  //   if ((Total_length % 10) != 0) {
  //     Total_req += 1;
  //   }

  //   var cont = 10;
  //   if (Total_length < cont) {
  //     cont = Total_length;
  //   }

  //   for (var j = 0; j < Total_req; j++) {
  //     this.ReqObj[Reqest_no] = { 'Topic': 9003 + Reqest_no, 'MREQ': MaxRegister };
  //     this.ReqObj[Reqest_no]['DEVID'] = this.EMIndex + 1;
  //     this.ReqObj[Reqest_no]['SID'] = SlaveID;
  //     var CharIndex = 0;
  //     for (var i = index; i < cont; i++) {
  //       if (MaxRegister > i) {

  //         var ReqRNo = this.List[CharIndex];
  //         var ReqRFields = this.List[CharIndex] + '1';

  //         this.ReqObj[Reqest_no][ReqRNo] = this.registerpanelForm.value.listRegisterdata[i].RegisterNO;
  //         this.ReqObj[Reqest_no][ReqRFields] = this.registerpanelForm.value.listRegisterdata[i].DataType + '/' + this.registerpanelForm.value.listRegisterdata[i].FunctionCode + '/' + this.registerpanelForm.value.listRegisterdata[i].DecimalPoint + '/' + this.registerpanelForm.value.listRegisterdata[i].ReadWriteAction;
  //       }

  //       CharIndex += 1;
  //     }
  //     index = cont;
  //     cont += 10;
  //     Reqest_no += 1;

  //   }

  //   var data = [];
  //   for (i = 0; i < Total_req; i++) {
  //     var reqObj = {
  //       Topic: this.KeyID,// 'IOCL1000000005000097',// reqparam.EnergymeterId,// 'SIPL_RECICLAR/SMIT_1937',
  //       PublishMessageJson: JSON.stringify(this.ReqObj[i])
  //     }
  //     data.push(reqObj);
  //   }

  //   var reqobj = {
  //     Data: data
  //   };
  //   this.SendDatabyMQTT(reqobj);
  // }

  // MQTT senddata function
  SendDatabyMQTT(reqObj) {
    this.errorMsg = '';
    this.successMsg = '';
    this.mqttoperation.PublishdatabyMQTT(reqObj).subscribe(
      (result: any) => {
        if (result == '0') {
          this.successMsg = 'Configuration value submitted successfully';
        }
        else {
          // this.errorMsg = 'Submittion Fail,Somthing Went Wrong';
          this.errorMsg = 'There are ' + result + ' requests are pending to acknowledge from device.';
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  AddNewParameterConfig(ParameterConfigId, index) {
    if (this.data.EnergyMeterdata.EMID == 0) {
      this.isDivVisible = true;
    }
    else {
      const dashboardconfig = this.dialog.open(AddnewparameterconfigComponent, {
        width: '700px',
        height: '400px',
        data: {
          data: ParameterConfigId, 'selectedmetername': this.selectedmetername, 'id': this.selectedmeterid,
          IsForview: 'N', 'otherdata': this.newdata
        }
      })
      dashboardconfig.afterClosed().subscribe(

        (result) => {
          if (ParameterConfigId != 0) {
            this.energyListOfPopup.push(result)

            this.registerpanelForm['controls'].listRegisterdata['controls'][index]['controls'].RegisterName.patchValue(result.RegisterName);
            this.registerpanelForm['controls'].listRegisterdata['controls'][index]['controls'].Formula.patchValue(result.Formula);
            this.registerpanelForm['controls'].listRegisterdata['controls'][index]['controls'].TagId.patchValue(result.TagId);
            this.registerpanelForm['controls'].listRegisterdata['controls'][index]['controls'].TempFormula.patchValue(result.TempFormula);
          }
          this.newdata = result


          if (ParameterConfigId == 0) {
            const control = <FormArray>this.registerpanelForm.controls['listRegisterdata'];

            control.push(
              this.form.group({
                RegisterName: new FormControl(result.RegisterName, [Validators.required]),
                RegisterNO: new FormControl(1, [Validators.required]),
                DataType: new FormControl('0', [Validators.required]),
                FunctionCode: new FormControl('1', [Validators.required]),
                DecimalPoint: new FormControl('0', [Validators.required]),
                ReadWriteAction: new FormControl('0', [Validators.required]),
                IsDisplayGraph: new FormControl(result?.IsDisplayGraph ? (result?.IsDisplayGraph.toString() == 'true') ? true : false : false),
                IsTotalizer: new FormControl(result?.IsTotalizer ? (result?.IsTotalizer.toString() == 'true') ? true : false : false),
                AlertId: new FormControl(this.defaultAlertId, [Validators.required]),
                HighThresoldValue: new FormControl(0, [Validators.required]),
                LowThresoldValue: new FormControl(0, [Validators.required]),
                RegisterSeq: (result?.RegisterSeq ? result?.RegisterSeq : 0),
                Unit: new FormControl("NONE", [Validators.required]),
                FullScale: new FormControl(0, [Validators.required]),
                Location: new FormControl(0, [Validators.required]),
                ZeroScale: new FormControl(0, [Validators.required]),
                RegisterDataId: result?.RegisterDataId,
                DecimalPointForFront: new FormControl('0', [Validators.required]),
                IsFromParameterConfig: result.IsFromParameterConfig,
                Formula: result.Formula,
                TagId: result.TagId,
                TempFormula: result.TempFormula,

              })
            );

            this.EnergyMeterdata.MaxRegisters = parseInt(this.EnergyMeterdata.MaxRegisters) + 1

            this.registerpanelForm.patchValue({
              MaxRegisters: this.EnergyMeterdata.MaxRegisters

            });
          }
        }
      );
    }
  }

  DeleteParamterData(event: any, index) {
    this.errorMsg = '';
    this.successMsg = '';

    const targetRegisterDataId = event.value.RegisterDataId;

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '35%',
      disableClose: true

    })
    dialogRef.afterClosed().subscribe(

      (result) => {
        if (result == 'Y') {
          const control = <FormArray>this.registerpanelForm.controls['listRegisterdata'];
          if (index >= 0) {
            control.removeAt(index);
            this.EnergyMeterdata.MaxRegisters = parseInt(this.EnergyMeterdata.MaxRegisters) - 1
            this.registerpanelForm.patchValue({
              MaxRegisters: this.EnergyMeterdata.MaxRegisters
            });
          }
        }
      }
    );
  }

  changeModbusRequestType(event: any) {
    if (event.value == '1') {
      this.showvalue = true
    }
    else {
      this.showvalue = false
    }
  }
  OnSlveId(event: any) {
    this.selectedslaveid = event.value
  }
  //Call on Upload File click
  UploadCalibrationCertificate() {
    const UploadLogodialogref = this.dialog.open(UploadFileComponent, {
      width: '70%',
      height: '40%',
      data: {
        MeterId: this.EnergyMeterID ? this.EnergyMeterID : 0
      }
    });

    //Callback on close popup and assign values
    UploadLogodialogref.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.CalibrationCertificatefilename = result;
        }
      })
  }
  SaveDeviceSettings() {
    this.errorMsgdevice = "";
    this.successMsgdevice = "";

    this.registerpanelForm.value.MaxRegisters = 1
    this.registerpanelForm.value.StartRegisterNumber = 0
    this.registerpanelForm.value.ReadRegisterQuantity = 0
    this.registerpanelForm.value.DataType = 0

    const obj = {
      SerialNumber: this.deviceSettingsForm.value.SerialNumber,
      LastCalibrationDate: this.deviceSettingsForm.value.LastCalibrationDate
        ? [formatDate(this.deviceSettingsForm.value.LastCalibrationDate, 'yyyy-MM-dd', 'en')][0]
        : null,
      LastCalibrationDueDate: this.deviceSettingsForm.value.LastCalibrationDueDate
        ? [formatDate(this.deviceSettingsForm.value.LastCalibrationDueDate, 'yyyy-MM-dd', 'en')][0]
        : null,
      CalibrationCertificate: this.CalibrationCertificatefilename,
      EnergymeterMasterId: this.EnergyMeterID ? this.EnergyMeterID : 0,

      UserId: localStorage.getItem("UserId")
    };
    this.meterConfiguration = obj

    // Array to collect error messages
    const missingFields: string[] = [];

    // Check each field and add to error message if missing
    if (!obj.SerialNumber) {
      missingFields.push("Serial Number");
    }
    if (!obj.LastCalibrationDate) {
      missingFields.push("Last Calibration Date");
    }
    if (!obj.LastCalibrationDueDate) {
      missingFields.push("Last Calibration Due Date");
    }
    if (!obj.CalibrationCertificate) {
      missingFields.push("Calibration Certificate");
    }

    // If any fields are missing, set the error message
    if (missingFields.length > 0) {
      this.errorMsgdevice = `Please fill out the following field(s): ${missingFields.join(", ")}.`;
      return; // Exit the function if validation fails
    }


    if (this.EnergyMeterID > 0) {
      this.SaveMeterConfigurationData(obj);
    }
    else {
      let reqparam = { ...this.registerpanelForm.value };
      this.RegisterDataparam = reqparam

      var objclose = {
        RegisterData: this.RegisterDataparam,
        meterConfiguration: this.meterConfiguration
      }

      this.dialogRef.close(objclose);
    }
  }
  SaveMeterConfigurationData(obj) {
    this.errorMsgdevice = ""
    this.successMsgdevice = ""
    this.GSMConfigService.SaveMeterConfigurationData(obj).subscribe(
      (result: any) => {
        if (result) {
          this.successMsgdevice = "Device settings saved successfully!";
        }

      },
      (error) => {
        this.errorMsgdevice = error;
      }
    );
  }
}
